module.exports = __webpack_public_path__ + "img/Reg-prog.e39d72bd.svg";